module.exports = function getResource(label, vars = []) {
    const resources = {
        review: 'Commentaire',
        rateHeading: 'Évaluer ce produit',
        writeReview: 'Rédiger votre commentaire',
        rateAndReview: 'Évaluer et commenter',
        headline: 'Titre',
        optional: 'facultatif',
        addAHeadline: 'Ajouter un titre',
        maxChar: `Max. ${vars[0]} caractères`,
        seeFull: 'Voir en entier',
        addPhoto: 'Ajouter une photo',
        upToTwoImages: 'jusqu’à deux images',
        wouldYouRecommendThisProduct: 'Recommanderiez-vous ce produit?',
        yes: 'Oui',
        no: 'Non',
        productAsAfreeSample: 'J’ai reçu ce produit en échantillon gratuit',
        sephoraEmployee: 'Je suis un employé de Sephora',
        next: 'Suivant',
        errorMessageText: `L’évaluation doit comporter au moins ${vars[0]} caractères`,
        errorMessageRating: 'Veuillez sélectionner une étoile pour évaluer',
        errorMessageTextRecommend: 'Veuillez faire un choix'
    };
    return resources[label];
};
